import React from 'react'

import { Button } from '@/components'
import { t } from '@/i18n'

import { useSearch } from '../SearchContext'

const ActiveFilter: React.FC = () => {
  const { filter, clearFilters, onChangeFilter } = useSearch()

  if (!filter.length) return null

  return (
    <div className="active-filters">
      <div className="remove-btn">
        {filter.map(_filter => {
          return (
            <Button
              key={_filter}
              className="main-btn blank"
              onClick={() => onChangeFilter(_filter)}
            >
              {t(_filter)}
              <span className="icon-close"></span>
            </Button>
          )
        })}
      </div>
      <div className="clear-btn">
        <Button className="main-btn blank" onClick={clearFilters}>
          {t('clearAll')}
        </Button>
      </div>
    </div>
  )
}

export default ActiveFilter
